<template>
    <div class="flex flex-col w-full pb-28 text-center">
      <div class="flex flex-col items-center w-full max-w-[1200px] mx-auto pt-20 border border-transparent">
        <h2 class="leading-[52px] mb-2 text-[40px] text-center">{{ $t("cpts.scenes.title") }}</h2>
        <p class="max-w-max text-[18px] leading-[24px] text-[#272a36] text-center">{{ $t("cpts.scenes.intro") }}</p>

        <el-tabs v-model="activeScene" class="w-full mt-[86px]">
          <el-tab-pane v-for="scene in scenes" :key="scene.name" :name="scene.name">
            <div slot="label">
              <div class="flex justify-center items-center h-[92px] mb-[33px]">
                <img :src="getImg(scene.img)" alt="" width="85px" height="88px">
              </div>
              <span class="block h-[48px] text-[16px] leading-[25px] text-[#00414a] mb-[26px] text-wrap">{{scene.label}}</span>
            </div>
            <div class="flex justify-between items-center min-h-[301px] bg-[#00414a] rounded-xl pt-0 px-[40px]">
              <div>
                <h3 class="text-[36px] leading-[55px] text-white mb-[3px] text-left">{{scene.label}}</h3>
                <p class="text-[18px] leading-[30px] text-white text-left">{{scene.detail}}</p>
              </div>
              <div>
                <a class="block bg-[#faa94c] rounded-[4rem] py-[16px] px-[42px] text-[16px] leading-[25px] text-white" :href="scene.url" target="_blank">{{ $t("cpts.scenes.learn_more") }}</a>
              </div>
            </div>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
</template>

<script>
export default {
  name: "solutions-view",
  data() {
    return {
      activeScene: "EC",      
    }
  },
  computed: {
    scenes() {
      return this.$t("cpts.scenes.items");
    }
  },
  methods: {
    getImg(img) {
      return require(`@/assets/index/img/index/${img}`);
    },
  }
}
</script>

<style scoped>

</style>